module.exports = __webpack_public_path__ + "static/media/logo-uniao-seguradora-negativo.23145a66.png";